import React, { useState } from 'react';
import { Undo2, LayoutTemplate } from 'lucide-react';
import { toast } from 'sonner';
import { BRAIN_TEMPLATES } from './brainTemplates';

export const BrainTemplatePicker = ({ businessName, prompt, greeting, onApply }) => {
  const [previous, setPrevious] = useState(null);
  const name = businessName?.trim() || 'the business';

  const apply = (t) => {
    setPrevious({ prompt, greeting });
    onApply({ prompt: t.prompt(name), greeting: t.greeting(name) });
    toast.success(`${t.label} template applied`);
  };

  const undo = () => {
    onApply(previous);
    setPrevious(null);
    toast.success('Restored previous prompt');
  };

  return (
    <div className="mb-3" data-testid="brain-template-picker">
      <div className="flex items-center gap-2 mb-2 text-xs font-medium text-slate-600">
        <LayoutTemplate className="w-4 h-4" /> Quick-start templates
      </div>
      <div className="flex flex-wrap gap-2">
        {BRAIN_TEMPLATES.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => apply(t)}
            className="px-3 py-1.5 rounded-full text-xs font-medium bg-white border border-slate-300 text-slate-700 hover:border-blue-500 hover:text-blue-600 transition-colors"
            data-testid={`brain-template-${t.key}`}
          >
            {t.label}
          </button>
        ))}
        {previous && (
          <button
            type="button"
            onClick={undo}
            className="px-3 py-1.5 rounded-full text-xs font-medium bg-amber-50 border border-amber-300 text-amber-700 hover:bg-amber-100 transition-colors flex items-center gap-1"
            data-testid="brain-template-undo"
          >
            <Undo2 className="w-3 h-3" /> Undo
          </button>
        )}
      </div>
    </div>
  );
};
